"use strict";

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@8base/utils");

var web_auth0_auth_client_1 = require("@8base/web-auth0-auth-client");

var web_cognito_auth_client_1 = require("@8base/web-cognito-auth-client");

var web_oauth_client_1 = require("@8base/web-oauth-client");

var api_token_auth_client_1 = require("@8base/api-token-auth-client");

var constants_1 = require("./constants");

var SubscribableDecorator_1 = require("./SubscribableDecorator");

var getAuthClientConstructor = function getAuthClientConstructor(strategy) {
  switch (strategy) {
    case constants_1.AUTH_STRATEGIES.API_TOKEN:
      {
        return api_token_auth_client_1.ApiTokenAuthClient;
      }

    case constants_1.AUTH_STRATEGIES.WEB_8BASE:
    case constants_1.AUTH_STRATEGIES.WEB_AUTH0:
      {
        return web_auth0_auth_client_1.WebAuth0AuthClient;
      }

    case constants_1.AUTH_STRATEGIES.WEB_OAUTH:
      {
        return web_oauth_client_1.WebOAuthClient;
      }

    case constants_1.AUTH_STRATEGIES.WEB_COGNITO:
      {
        return web_cognito_auth_client_1.WebCognitoAuthClient;
      }
  }
};

var Auth =
/*#__PURE__*/
function () {
  function Auth() {
    _classCallCheck(this, Auth);
  }

  _createClass(Auth, null, [{
    key: "createClient",
    value: function createClient(options, clientOptions) {
      utils_1.throwIfMissingRequiredParameters(['strategy'], utils_1.PACKAGES.AUTH, options);
      utils_1.showWarningIfDeprecatedParameters(['storage', 'storageKey'], utils_1.PACKAGES.AUTH, options);
      var strategy = options.strategy,
          subscribable = options.subscribable;
      var storageOptions = !!options.storageOptions ? options.storageOptions : {
        // @ts-ignore
        storage: options.storage,
        // @ts-ignore
        storageKey: options.storageKey
      };
      var Constructor = getAuthClientConstructor(strategy);
      var authClient = new Constructor(clientOptions, storageOptions);

      if (subscribable) {
        authClient = SubscribableDecorator_1.SubscribableDecorator.decorate(authClient);
      }

      return authClient;
    }
  }]);

  return Auth;
}();

exports.Auth = Auth;